import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { maskMiddle, returnOptionText, textSubStr } from "../hooks/basicFunc";
import NoHistory from "../myPage/NoHistory";

const AmoHistoryComponent = (props) => {
  const { data } = props;

  return (
    <>
      {data.length == 0 ? (
        <NoHistory />
      ) : (
        <Table>
          <thead>
            <tr>
              <th>거래일시</th>
              <th>From</th>
              <th>To</th>
              <th>아모시세</th>
              <th>수수료</th>
              <th>TX Id</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 &&
              data.map((li, index) =>
                li.logs.map((list, index) => (
                  <tr key={index}>
                    <td className="date">
                      {textSubStr(list.time)[0]}
                      <br />
                      {textSubStr(list.time)[1]}
                    </td>
                    <td>
                      {list.from}
                      <br />
                      {list.type == "mup2amo" ? (
                        <span>mup</span>
                      ) : (
                        <span>amo</span>
                      )}
                    </td>
                    <td>
                      {list.to}
                      <br />
                      {list.type == "mup2amo" ? (
                        <span>amo</span>
                      ) : (
                        <span>mup</span>
                      )}
                    </td>
                    <td>{list.amoPrice}</td>
                    <td>{list.fee}</td>
                    <td>
                      <p
                        onClick={() => {
                          window.open(
                            `https://klaytnscope.com/tx/${list.amoTx}`
                          );
                        }}
                      >
                        {maskMiddle(list.amoTx)}
                      </p>
                    </td>
                  </tr>
                ))
              )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default AmoHistoryComponent;
const Table = styled.table`
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.2rem;
  width: 100%;
  text-align: right;
  .date {
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 400;
  }
  thead {
    height: 4.2rem;
    border-bottom: 1px solid ${({ theme }) => theme.color.black};
    th {
      line-height: 4.2rem;
    }
  }
  tr {
    :nth-child(1) {
      padding-left: 1rem;
      text-align: left;
    }
    :nth-child(2) {
      text-align: center;
    }
    :nth-child(3) {
      text-align: center;
    }
    :nth-last-child(1) {
      text-align: right;
    }
  }
  tbody {
    tr {
      height: 5rem;
      border-bottom: 1px dotted #000;
      span {
        color: ${({ theme }) => theme.color.input_text_gray_dark};
        text-align: center !important;
        display: block;
        font-weight: 500;
      }
    }
    :nth-last-child(1) {
      border-bottom: 0;
    }
  }
`;
